export default __webpack_public_path__ + "static/article-are-you-financially-responsible-8d5af48b366b5b2320dc9510194dcc93.jpg";